"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(state) {
  var _state$assignmentProg, _state$assignmentProg2, _state$assignmentProg3, _state$assignmentProg4;
  var language = (_state$assignmentProg = state.assignmentProgress) === null || _state$assignmentProg === void 0 ? void 0 : _state$assignmentProg.language;
  var deploymentId = (_state$assignmentProg2 = state.assignmentProgress) === null || _state$assignmentProg2 === void 0 ? void 0 : _state$assignmentProg2.deployment_id;
  var surveyHandle = (_state$assignmentProg3 = state.assignmentProgress) === null || _state$assignmentProg3 === void 0 ? void 0 : (_state$assignmentProg4 = _state$assignmentProg3.surveylist) === null || _state$assignmentProg4 === void 0 ? void 0 : _state$assignmentProg4.handle;
  if (!language || !deploymentId || !surveyHandle) {
    return [];
  }
  var arr = (0, _get2["default"])(state, "surveyProgress.".concat(surveyHandle, ".").concat(language), []);
  return arr.filter(function (item) {
    return item.flow_started;
  }).map(function (item) {
    return {
      started: Boolean(item.flow_started),
      completed: Boolean(item.flow_finished),
      lastVisited: item.flow_last_visited,
      flowHandle: item.survey_handle,
      flowLanguage: language,
      responseSet: deploymentId
    };
  });
};